import { render, staticRenderFns } from "./coupon-rate.vue?vue&type=template&id=5c2e1005&scoped=true"
import script from "./coupon-rate.vue?vue&type=script&lang=js"
export * from "./coupon-rate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2e1005",
  null
  
)

export default component.exports